(function () {
  function initCustomJs($) {
    $(document).ready(() => {
      ($(".trigger-secondary").click(function () {
        $(this).hasClass("secondary-open")
          ? $(this).removeClass("secondary-open")
          : $(this).addClass("secondary-open");
      }),
        $("#menuToggle").click(() => {
          ($(".mobile-menu-container").addClass("open"),
            $(".mobile-menu").addClass("open"),
            $("html").css("overflow", "hidden"),
            $("body").css("overflow", "hidden"));
        }),
        $(".mobile-menu .close-menu").click(() => {
          ($(".mobile-menu").removeClass("open"),
            $(".mobile-menu-container").removeClass("open"),
            $("html").css("overflow", ""),
            $("body").css("overflow", ""));
        }));
    });

    function initSwiper(selector, options) {
      if (typeof Swiper === "undefined" || !document.querySelector(selector)) {
        return null;
      }

      return new Swiper(selector, options);
    }

    $(".link-container .double").parent().addClass("has-double");

    var galleryThumbs = initSwiper(".gallery-thumbs", {
        spaceBetween: 11,
        slidesPerView: 6,
        breakpoints: {
          750: {
            direction: "vertical",
            spaceBetween: 1,
            centerInsufficientSlides: !1,
            slidesPerView: "auto",
          },
        },
      }),
      galleryTop = initSwiper(".gallery-top", {
        slidesPerView: 1,
        simulateTouch: !1,
        spaceBetween: 15,
        navigation: {
          nextEl: ".swiper-button-next.article-arrows",
          prevEl: ".swiper-button-prev.article-arrows",
        },
        breakpoints: {
          750: {
            direction: "vertical",
            slidesPerView: "auto",
            simulateTouch: "true",
            touchReleaseOnEdges: "true",
          },
        },
        thumbs: {
          swiper: galleryThumbs,
        },
      }),
      matchingAccessories = initSwiper(".matching-accessories", {
        slidesPerView: 2,
        spaceBetween: 15,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      }),
      customerStyles = initSwiper(".style-swiper", {
        slidesPerView: 1.5,
        spaceBetween: 36,
        roundLengths: !0,
        centerInsufficientSlides: !0,
        navigation: {
          nextEl: ".style-swiper ~ .swiper-button-next",
          prevEl: ".style-swiper ~ .swiper-button-prev",
        },
        breakpoints: {
          750: {
            slidesPerView: 3,
            watchOverflow: !0,
          },
        },
      });

    function swatchDelay() {
      ($(".swatchColor").each(function () {
        $(this).hasClass("currentSwatch") &&
          $(".selected-swatch").text(": " + this.textContent);
      }),
        $(".swatchColor").click(function () {
          $(".selected-swatch").text(": " + this.textContent);
        }));
    }

    (setTimeout(
      function () {
        initSwiper(".recommendations-swiper", {
          slidesPerView: 2.2,
          spaceBetween: 20,
          roundLengths: !0,
          breakpoints: {
            750: {
              slidesPerView: 3,
              simulateTouch: !1,
            },
            1024: {
              slidesPerView: 4,
              simulateTouch: !1,
            },
          },
        });
      },

      1e3,
    ),
      $.fn.fancybox &&
        $('[data-fancybox="gallery"], .customer-style').fancybox({
          buttons: ["zoom", "close"],
        }));
    $(".swatch-container").each(function () {
      var e = $(this).find(".selected-option");
      var i = $(this).find(".swatch-element");
      var atc = $(".details-container form .atc");
      var atcText = $(".details-container form .atc span");
      $(i).click(function () {
        $(e).text(": " + this.textContent);
        if ($(this).hasClass("soldout")) {
          atc.addClass("disabled");
          atcText.text("Sold Out");
        } else {
          atc.removeClass("disabled");
          atcText.text("ADD TO CART");
        }
      });
    });
    $(document).ready(function () {
      (setTimeout(swatchDelay, 600),
        $(window)
          .bind("resize", function () {
            $(this).width() > 749 &&
              $.fn.stick_in_parent &&
              $(
                ".multiImage .gallery-thumbs, .details.multiImage",
              ).stick_in_parent({
                offset_top: 70,
              });
          })
          .trigger("resize"));
    });
  }

  var jqueryAttempts = 0;

  function waitForJQuery() {
    if (window.jQuery) {
      initCustomJs(window.jQuery);
      return;
    }

    jqueryAttempts += 1;

    if (jqueryAttempts < 120) {
      window.setTimeout(waitForJQuery, 50);
    }
  }

  waitForJQuery();
})();
